module.exports = __webpack_public_path__ + "img/3.c35bca84.png";